// Tiny TOTP helpers shared by the enrollment surfaces (login first-login setup,
// the forced-enrollment guard, and the Settings security panel). Kept in its
// own module so the eager login bundle can reuse it without pulling in the
// lazily-loaded Settings page.

// Extract the base32 `secret` from an otpauth:// provisioning URI so it can be
// shown for manual entry when a QR scan isn't possible.
export function secretFromProvisioningUri(uri: string): string | null {
  const m = /[?&]secret=([^&]+)/.exec(uri);
  return m ? decodeURIComponent(m[1]!) : null;
}
